module.exports = __webpack_public_path__ + "media/img/ms-icon-310x310-1cbd101c156140caab5e38a31e29d9bc.png";